import { Flex, Text } from "@chakra-ui/react";

// Mirrors the mobile ReadingCategory component: a small uppercase label.
const SectionTitle = ({ children, ...props }) => (
  <Flex alignItems="center" my="8px" {...props}>
    <Text
      flexShrink={0}
      color="#8F9BB3"
      fontSize="11px"
      lineHeight="16px"
      fontWeight="700"
      letterSpacing="0.7px"
    >
      {children}
    </Text>
  </Flex>
);

export default SectionTitle;
